export default "__VITE_ASSET__BUIovXmf__"